import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Message from "../../components/Message";
import CreatableSelect from "react-select/creatable";
import { skillsdata } from "../../data/skillsdata";
import { applyDeveloper, learnDeveloper } from "../../actions/developerAction";
import Login from "../Login";
import "../../styles/requestdetails.css";
import collaboration from "../../assets/collaboration.svg";

import { Upload, message } from "antd";
import { InboxOutlined } from "@ant-design/icons";

const { Dragger } = Upload;

const DeveloperDetailsRequest = ({ history }) => {
  const [selectValue, setSelectValue] = useState("");
  const [bio, setBio] = useState("");
  const [github, setGithub] = useState("");
  const [cv, setCv] = useState("");
  const [skillslevel, setSkillslevelValue] = useState("");
  const [skills, setSkills] = useState("");
  const [phone, setPhone] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [path, setPath] = useState("");

  const [fileList, setFileList] = useState([]);
  const [cloudList, setCloudList] = useState([]);

  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);

  const { userInfo } = userLogin;

  const developerApplyState = useSelector((state) => state.developerApply);

  const { developerApply, loading, error } = developerApplyState;

  const developerLearnState = useSelector((state) => state.developerLearn);

  const {
    developerLearn,
    loading: learnloading,
    error: learnerror,
  } = developerLearnState;

  // useEffect(() => {
  //   if (!userInfo) {
  //     history.push("/login");
  //   }
  // }, [history, userInfo]);

  if (!userInfo) {
    return <Login />;
  }

  if (userInfo && userInfo.role === "employer") {
    history.push("/employer/dashboard");
  }

  const handleSelect = (newValue, actionMeta) => {
    let skillArr = newValue.map((item) => {
      return item.value;
    });
    setSkills(skillArr);
    setPath(skillArr);
  };

  const handleChange = (info) => {
    let fileList = [...info.fileList];

    // 1. Limit the number of uploaded files
    // Only to show two recent uploaded files, and old ones will be replaced by the new
    fileList = fileList.slice(-1);

    // 2. Read from response and show file link
    fileList = fileList.map((file) => {
      if (file.response) {
        // Component will show file.url as link
        file.url = file.response.url;
      }
      return file;
    });

    setFileList(fileList);
  };

  const dummyRequest = ({ file, onSuccess }) => {
    const image = new FormData();
    image.append("upload_preset", "fz0bvgt7");
    image.append("file", file);
    const config = {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    };
    axios
      .post("https://api.cloudinary.com/v1_1/teqporte/upload", image, config)
      .then((res) => {
        const secureUrl = res.data.secure_url;
        const newList = [secureUrl];
        setCloudList(newList);
        setCv(newList);
      });
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const applySubmit = (e) => {
    e.preventDefault();
    if (!skills.length) {
      return message.error("Expertise field is required");
    }
    dispatch(applyDeveloper(skills, skillslevel, bio, cv, github, history));
  };

  const learnSubmit = (e) => {
    e.preventDefault();
    if (!skills.length) {
      return message.error("Path field is required");
    }
    dispatch(learnDeveloper(phone, country, state, path, history));
  };

  return (
    <div className="request">
      {error && <Message variant="danger">{error}</Message>}
      {learnerror && <Message variant="danger">{learnerror}</Message>}
      <div className="left">
        <div>
          <div className="logo" href="/">
            wedevelopers
          </div>
        </div>
        <div>
          <h4 className="font-subhead lh-small mt-4 my-2">
            Join our team of developers
          </h4>
          <p className="font-normal">Apply for top software engineering jobs</p>
        </div>
        <div className="mt-2">
          <img
            className="w-100"
            src={collaboration}
            alt="collaboration illustration"
          />
        </div>
      </div>
      <div className="right">
        <div className="text-center logo-sm mt-2">
          <a className="logo" href="/">
            wedevelopers
          </a>
        </div>
        <div className="form-wrapper">
          <h3 className="lh-small font-subhead mt-4 mb-50">
            Make a request on wedevelopers.
          </h3>
          <p className="mb-2">Tell us what you need done.</p>
          <div className="w-100">
            <div>
              <select
                className="select mb-2"
                onChange={(e) => {
                  setSelectValue(e.target.value);
                }}>
                <option value="">What do you want to do?</option>
                <option value="apply">Apply as a developer</option>
                <option value="learn">Learn Coding</option>
              </select>
            </div>
            {selectValue === "apply" && (
              <form onSubmit={applySubmit}>
                <div className="mb-1">
                  <label className="mb-25 d-inline-block font-weight-bolder">
                    Expertise
                  </label>
                  <div className="input">
                    <CreatableSelect
                      isMulti
                      name="skill"
                      options={skillsdata}
                      onChange={handleSelect}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="e.g. react, java, python"
                      required
                    />
                  </div>
                </div>
                <div className="mb-1">
                  <label className="mb-25 d-inline-block font-weight-bolder">
                    Expertise Level
                  </label>
                  <div className="input">
                    <select
                      className="select"
                      onChange={(e) => {
                        setSkillslevelValue(e.target.value);
                      }}
                      required>
                      <option value="beginner">Beginner (0-3years)</option>
                      <option value="intermediate">
                        Intermediate (3-5years)
                      </option>
                      <option value="expert">Expert (5+)</option>
                    </select>
                  </div>
                </div>
                <div className="mb-1">
                  <label className="mb-25 d-inline-block font-weight-bolder">
                    About you
                  </label>
                  <div className="input">
                    <p className="mb-25">Little bio about you</p>
                    <textarea
                      rows="10"
                      onChange={(e) => setBio(e.target.value)}
                      required></textarea>
                  </div>
                </div>
                {/* <div className="mb-1">
                  <label className="mb-25 d-inline-block font-weight-bolder">CV</label>
                  <div className="input">
                    <input
                      type="file"
                      name="cv"
                      placeholder="include your cv"
                    />
                  </div>
                </div> */}
                <div className="mb-1">
                  <label className="my-25 d-inline-block font-weight-bolder">
                    CV
                  </label>
                  <Dragger
                    fileList={fileList}
                    onChange={handleChange}
                    customRequest={dummyRequest}>
                    <p>
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">
                      Click or drag file to this area to upload
                    </p>
                  </Dragger>
                </div>
                <div className="mb-1">
                  <label className="mb-25 d-inline-block font-weight-bolder">
                    Github Username
                  </label>
                  <div className="input">
                    <input
                      type="text"
                      name="github"
                      placeholder="e.g. petrepan"
                      onChange={(e) => setGithub(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="my-2">
                  <button
                    className="d-flex justify-content-center button"
                    type="submit">
                    {loading ? <div className="spinner"></div> : "SUBMIT"}
                  </button>
                </div>
              </form>
            )}

            {selectValue === "learn" && (
              <form onSubmit={learnSubmit}>
                <p className="mb-1">
                  Begin your career as a software engineering
                </p>
                <div className="mb-1">
                  <label className="mb-25 d-inline-block font-weight-bolder">
                    Phone Number
                  </label>
                  <div className="input">
                    <input
                      type="number"
                      name="number"
                      placeholder="Enter your phone number"
                      onChange={(e) => setPhone(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="mb-1">
                  <label className="mb-25 d-inline-block font-weight-bolder">
                    Country
                  </label>
                  <div className="input">
                    <input
                      type="text"
                      name="country"
                      placeholder="Enter country"
                      onChange={(e) => setCountry(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="mb-1">
                  <label className="mb-25 d-inline-block font-weight-bolder">
                    State
                  </label>
                  <div className="input">
                    <input
                      type="text"
                      name="state"
                      placeholder="Enter State"
                      onChange={(e) => setState(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="mb-1">
                  <label className="mb-25 d-inline-block font-weight-bolder">
                    What tech path
                  </label>
                  <div className="input">
                    <CreatableSelect
                      isMulti
                      name="skill"
                      options={skillsdata}
                      onChange={handleSelect}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="e.g. frontend, backend, data science"
                      required
                    />
                  </div>
                </div>
                <div className="my-2">
                  <button
                    className="d-flex justify-content-center button"
                    type="submit">
                    {learnloading ? <div className="spinner"></div> : "SUBMIT"}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeveloperDetailsRequest;
